var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fs-table-body',[_c('tr',{class:("transition duration-100 border-b border-gray-200 " + _vm.showMode)},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }